import { useState } from "react";

interface ShareBarProps {
  title: string;
}

const shareTargets = [
  { key: "wechat", label: "微信", icon: "ri-wechat-line" },
  { key: "weibo", label: "微博", icon: "ri-weibo-line" },
  { key: "link", label: "复制链接", icon: "ri-link" },
];

export default function ShareBar({ title }: ShareBarProps) {
  const [toast, setToast] = useState("");

  const handleShare = (key: string, label: string) => {
    if (key === "link") {
      const url = window.location.href;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).catch(() => undefined);
      }
      setToast("链接已复制，分享给朋友吧");
    } else {
      setToast(`已唤起分享到「${label}」（演示效果）：${title}`);
    }
    window.setTimeout(() => setToast(""), 2600);
  };

  return (
    <div className="relative">
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-sm text-foreground-500">分享：</span>
        {shareTargets.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => handleShare(item.key, item.label)}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-200 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
          >
            <i className={item.icon} />
            {item.label}
          </button>
        ))}
      </div>
      {toast && (
        <div className="fixed bottom-24 left-1/2 z-[70] -translate-x-1/2 rounded-full bg-foreground-950 px-5 py-3 text-sm text-background-50">
          {toast}
        </div>
      )}
    </div>
  );
}